import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function AlertDialog({ open, handleClose, missingCities }) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiDialogTitle-root': {
                    fontFamily: 'Poppins, sans-serif',  // Change font-family for title
                },
                '& .MuiDialogContent-root': {
                    fontFamily: 'Poppins, sans-serif',  // Change font-family for content
                }
            }}
        >

            <DialogTitle id="alert-dialog-title">
                {"Action Required: Upload Your Image"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ fontFamily: 'Poppins, sans-serif', color: "rgba(0, 0, 0, 0.77)" }}>
                    Your ad will not appear on the community profile page until an image is uploaded.
                    {/* Please upload an image to make your ad visible to others. */}
                    <br />
                    <strong>Cities missing banners:</strong>
                    {missingCities.length > 0 ? (
                        <ul>
                            {missingCities.map((city, index) => (
                                <li key={city?.id + index}>{city?.city}</li>
                            ))}
                        </ul>
                    ) : (
                        " No missing banners."
                    )}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={handleClose}>Disagree</Button> */}
                <button className='bttn-close' onClick={handleClose} autoFocus>
                    Close
                </button>
            </DialogActions>
        </Dialog>
    );
}